import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Topbar from '../layout/Topbar';
import { RotatingLines } from 'react-loader-spinner';
import authApi from '../../api/authApi';
import { getErrorMessage, logError } from '../../utils/errorHandler';
import Countdown from 'react-countdown';

const Reset = () => {
    const [position, setPosition] = useState('');
    const [email, setEmail] = useState('');
    const [msg, setMsg] = useState('');
    const [kode, setKode] = useState('');
    const [loading, setLoading] = useState(false);
    const [isDisabled, setDisabled] = useState(true);
    const [countdown, setCountdown] = useState(Date.now() + 30000);

    const [password, setPassword] = useState('');
    const [confPassword, setConfPassword] = useState('');

    const navigate = useNavigate();

    const submitEmail = async () => {
        setLoading(true)
        setDisabled(true)
        try {
            const res = await authApi.post('/code', {
                email: email,
                type: 'reset',
            })
            console.log(res)
            if (res.status === 200) {
                setPosition(1)
                setCountdown(Date.now() + 30000)
            }
        } catch (error) {
            logError('Gagal mengirim kode reset:', error)
            setMsg(getErrorMessage(error, 'Gagal mengirim kode reset. Silakan coba lagi.'))
        }
        setLoading(false)
        setDisabled(false)
    }

    const submitVerify = async (kode) => {
        try {
            const res = await authApi.post('/verify', {
                email: email,
                code: kode,

            })
            console.log(res)
            setPosition(2);
        } catch (error) {
            logError('Verifikasi kode gagal:', error)
            setMsg(getErrorMessage(error, 'Kode Verifikasi Tidak Sesuai'))
        }
    }

    const submitPassword = async () => {
        setLoading(true)
        setDisabled(true)
        try {
            const res = await authApi.post('/save', {
                email: email,
                code: kode,
                new_password: password,
                confirm_password: confPassword
            });
            console.log(res);
            setMsg('Reset Password Berhasil, menuju ke halaman login dalam 3 detik')
            setTimeout(()=>{
                navigate('/login')
            },5000)
        } catch (error) {
            logError('Reset password gagal:', error)
            setMsg(getErrorMessage(error, 'Pastikan password sesuai'))
        }
        setLoading(false)
        setDisabled(false)
    }

    const handleChange = (email) => {
        // don't remember from where i copied this code, but this works.
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (re.test(email)) {
            // this is a valid email address
            // call setState({email: email}) to update the email
            // or update the data in redux store.
            setDisabled(false);
            setMsg('');
        }
        else {
            setDisabled(true);
            setMsg('format email tidak valid');
            // invalid email, maybe show an error to the user.
        }
        setEmail(email);
    }

    const handleChangeKode = (kode) => {
        setMsg()
        setKode(kode)
        if (kode.length === 6) {
            submitVerify(kode);
        }
    }

    // Countdown if complete component
    const Completionist = () => {
        if (!loading) {
            return (<span className='has-text-primary is-clickable' onClick={() => submitEmail()}> Kirim Ulang!</span>)
        }
        else {
            return (<></>)
        }
    }

    // Countdown Renderer callback with condition
    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a complete state
            return <Completionist />;
        } else {
            // Render a countdown
            return (
                <span> {seconds}</span>
            );
        }
    };

    const renderForm = () => {
        if (position === 1) {
            return (
                <div className='card-content'>
                    <div>
                        <p className="has-text-centered">{msg}</p>
                        <p>Masukkan kode verifikasi yang sudah kami kirim ke email {email}.</p>
                        <div className="field mt-5">
                            {/* <label className="label">Email</label> */}
                            <div className="controls">
                                <input type="text" className="input" placeholder=''
                                    value={kode} onChange={(e) => handleChangeKode(e.target.value)} />
                            </div>
                        </div>
                        <p>Belum menerima email?
                            <Countdown
                                date={countdown}
                                renderer={renderer}
                                key={countdown}
                            />
                        </p>
                    </div>
                </div>
            )
        } else if (position === 2) {
            return (
                <div className='card-content'>
                    <p className="has-text-centered">{msg}</p>
                    <p className="mb-2">Masukkan password yang baru</p>
                    <div className="field mt-5">
                        <label className="label">Password</label>
                        <div className="controls">
                            <input type="password" className="input" placeholder='********'
                                value={password} onChange={(e) => setPassword(e.target.value)} />
                        </div>
                    </div>
                    <div className="field mt-5">
                        <label className="label">Confirm Password</label>
                        <div className="controls">
                            <input type="password" className="input" placeholder='********'
                                value={confPassword} onChange={(e) => setConfPassword(e.target.value)} />
                        </div>
                    </div>
                    <div className="field mt-5">
                        <button className="button is-fullwidth has-background-primary-30 has-text-white"
                            onClick={() => submitPassword()} disabled={isDisabled}>
                            Simpan
                        </button>
                    </div>
                </div>
            )
        } else {
            return (
                <div className='card-content'>
                    <div>
                        <p>Masukkan email yang terdaftar. Kami akan mengirimkan kode verifikasi untuk atur ulang kata sandi</p>
                        <div className="field mt-5">
                            {/* <label className="label">Email</label> */}
                            <div className="controls">
                                <input type="email" className="input" placeholder='Email'
                                    value={email} onChange={(e) => handleChange(e.target.value)} />
                            </div>
                        </div>
                        <p>{msg}</p>
                        <div className='has-text-center is-fullwidth'>


                        </div>
                        <div className="field mt-5">
                            <button className="button is-fullwidth has-background-primary-30 has-text-white"
                                onClick={() => submitEmail()} disabled={isDisabled}>
                                Lanjut
                            </button>
                        </div>

                    </div>
                </div>
            )
        }
    }


    return (
        <div>
            <Topbar page={'reset'} />
            <div className="container p-5">
                <div className="columns is-centered">
                    <div className="column is-5-widescreen is-6-desktop is-7-tablet">
                        <div className='card'>
                            <header className='card-header'>
                                <p className='card-header-title'>Reset Password</p>
                                <div className='card-header-icon'>
                                    <RotatingLines
                                        visible={loading}
                                        height="20"
                                        width="20"
                                        strokeColor="gray"
                                        strokeWidth="5"
                                        animationDuration="0.75"
                                        ariaLabel="rotating-lines-loading"
                                    />
                                </div>
                            </header>
                            {renderForm()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Reset
